"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Spinner = function Spinner(props) {
  var styles = {
    width: (0, _utils.normalizeSize)(props.width),
    height: (0, _utils.normalizeSize)(props.height),
    color: props.color
  };
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('sk-fading-circle', props.className),
    style: styles
  }, _react["default"].createElement("div", {
    className: "sk-circle1 sk-circle"
  }), _react["default"].createElement("div", {
    className: "sk-circle2 sk-circle"
  }), _react["default"].createElement("div", {
    className: "sk-circle3 sk-circle"
  }), _react["default"].createElement("div", {
    className: "sk-circle4 sk-circle"
  }), _react["default"].createElement("div", {
    className: "sk-circle5 sk-circle"
  }), _react["default"].createElement("div", {
    className: "sk-circle6 sk-circle"
  }), _react["default"].createElement("div", {
    className: "sk-circle7 sk-circle"
  }), _react["default"].createElement("div", {
    className: "sk-circle8 sk-circle"
  }), _react["default"].createElement("div", {
    className: "sk-circle9 sk-circle"
  }), _react["default"].createElement("div", {
    className: "sk-circle10 sk-circle"
  }), _react["default"].createElement("div", {
    className: "sk-circle11 sk-circle"
  }), _react["default"].createElement("div", {
    className: "sk-circle12 sk-circle"
  }));
};

Spinner.propTypes = {
  /**
   * Class to be appended to thw wrapping element
   */
  className: _propTypes["default"].string,

  /**
   * Color of the dots
   */
  color: _propTypes["default"].string,

  /**
   * Height of the spinner
   */
  height: _propTypes["default"].number,

  /**
   * Width of the spinner
   */
  width: _propTypes["default"].number
};
Spinner.defaultProps = {
  className: '',
  color: '#6e7278',
  height: 40,
  width: 40
};
Spinner.displayName = 'Spinner';
var _default = Spinner;
exports["default"] = _default;